import {AiFillCaretDown, AiOutlineShoppingCart} from 'react-icons/ai'
import React from "react";
import '../Styles/Navigation.scss';
import CampConnect from "../Images/CampConnectLogo.svg";
import BrrCircleLogo from "../Images/BillRiceRanchCircleLogoWhite.png";
import {Link} from 'react-router-dom'
import Session from 'react-session-api';
import {useNavigate} from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import { useCart } from '../Contexts/CartContext';

function Navigation() {
   const location = useLocation();
   const {pathname} = location;

   const navigate = useNavigate();
   const { count } = useCart();

   // The cart only exists for signed-in individual accounts, so group and admin sessions never see it.
   const showCart = Session.get("isAuth") === "true" && Session.get("accountType") === "individual";

   const accountLogout = async () => {
       try {
         const response = await fetch('/api/logout', {
               method: 'GET',
               headers: { "Content-Type": "application/json" }
            })
         Session.set("isAuth", null)
         Session.set("accountType", null)

         if (response.status === 400 || response.status === 500) {
            throw new Error("Failed Logout");
         }
         
         navigate('/');
       } catch (err) {
          console.error(err.message);
      }
      }

   return (
       <div className="navbar">
          <div className="container-fluid">
             <div className="navLogo">
               <Link className = "navLink" to='https://billriceranch.org/'>Back to Bill Rice Ranch.com</Link>
             </div>
 
             <div className="links">
               <img src={BrrCircleLogo} alt="Bill Rice Ranch" className="headerLogo" />
             </div>
          <div className="signInButton">

            {showCart &&
               <div className="cartButton">
                  <Link to={'/mycart'} id='cart'
                     title="My Cart"
                     aria-label={`My cart, ${count} registration${count === 1 ? '' : 's'}`}>
                     <AiOutlineShoppingCart className="cartIcon" aria-hidden="true" />
                     {count > 0 && <span className="cartBadge">{count}</span>}
                  </Link>
               </div>
            }

            <div className="button1">
               {Session.get("isAuth") === "true" ?
                  <>
                  {(pathname === "/groupaccount" || pathname === "/individualaccount" || pathname === "/administration")?
                     <button onClick={accountLogout}>
                        Logout
                     </button>
                  :
                     <>
                     {Session.get("accountType") === "individual" ?
                        <Link to={'/individualaccount'} id='login'>
                           <button>
                              My Account
                           </button>
                        </Link>
                     :
                        <Link to={'/groupaccount'} id='login'>
                           <button>
                              My Account
                           </button>
                        </Link>
                     }
                     </>
                  }
                  </>
               :
                  <Link to={'/selectregistration'} id='login'>
                     <button>
                        Sign In
                     </button>
                  </Link>
               }
            </div>

          </div>
       </div>
     </div>
   )}
 export default Navigation;


